import styles from './blogs.module.css'
import { blogs } from '../../constants/blog-data'
import BlogCard from './BlogCard/BlogCard';
import HeadingTitle from '../shared/heading-title/HeadingTitle';
import { SubHeading, SubHeadingTitle } from '../shared';
import { TextAlignCenter } from 'lucide-react';

const Blogs = () => { 
  return (
     <section className={styles.blogs__wrapper}>
      <HeadingTitle text="Latest News & blog" style={styles.heading}/> 
       {/* <h3 style={{textAlign:"center",fontSize:"1.6rem"}}>News & Blog </h3> */}
      <HeadingTitle text=" News & blog"  style={styles.subhead} />
    <div className={styles.blogs__grid_wrapper}>
      
      {
        blogs?.map((item)=>{
          return(
            <BlogCard key={item?.id} blog={item}/>
          )
        })
      }
    </div>
      </section>
  )
}

export default Blogs
